import axios from '@/utils/request'
var Qs = require('qs')

export default {
	// 2020-11-28
	search(params) {
		return axios.get('/sales-targets?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
	},
	// 2020-11-28
	findByMonth(params) {
		return axios.get('/sales-targets/find-by-month', params);
	},
	// 2020-11-28
	delete(id) {
		return axios.delete('/sales-targets/' + id)
	},
	// 2020-11-28
	findById(params) {
		return axios.get('/sales-targets/find-by-id', params);
	}

}

